<template>
    <div>
        <div :class="{ 'cursor-pointer': collapsible }" class="flex items-center justify-between text-primary" @click.stop="toggleCollapse">
            <div class="flex items-center gap-1.5">
                <span>{{ name }}</span>
                <exclamation-mark v-if="showExpirationWarning" type="filled" />
            </div>
            <icon :key="open" :name="open ? 'cil-chevron-top' : 'cil-chevron-bottom'" />
        </div>
        <collapse :show="expanded" class="text-sm leading-5">
            <div v-if="description" class="mb-2 text-gray-500">
                {{ description }}
            </div>
            <stakeholder-contact-list :contacts="contacts" :title="contactsTitle" />
            <slot />
        </collapse>
    </div>
</template>
<script setup>
import Collapse from '@/Components/Collapse.vue';
import ExclamationMark from '@/../icons/ExclamationMark.vue';
import StakeholderContactList from '@/Pages/Stakeholders/Components/StakeholderContactList.vue';
import { ref, computed } from 'vue';

const props = defineProps({
    name: String,
    description: String,
    contacts: Array,
    contactsTitle: String,
    collapsible: {
        type: Boolean,
        default: true,
    },
    showExpirationWarning: {
        type: Boolean,
        default: false,
    },
});

const open = ref(!props.collapsible);

const expanded = computed(() => !props.collapsible || open.value);

const toggleCollapse = () => {
    if (!props.collapsible) {
        return;
    }
    open.value = !open.value;
};
</script>
